<template>
    <div>
        <input
                :name="name"
                :id="id"
                size="70"
                type="text"
                :value="computedValue"
                @change="onChange($event)"
        >&nbsp;
        <p>Introducir ids de geounits separador por comas.</p>
        <div v-if="showSpinner" class="spinner-border"></div>
        <p v-if="destinationsText">
            Destinos seleccionados: <b>{{ destinationsText }}</b>
        </p>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        name: 'purchase-destinations',
        props: {
            id : {
                type: String
            },
            name : {
                type: String
            },
            selectedValues : {
                type: String
            }
        },
        data () {
            return {
                value : null,
                destinationsText : null,
                showSpinner : false,
            };
        },
        computed: {
            computedValue: function () {
                return this.value !== null ? this.value : this.selectedValues;
            }
        },
        methods: {
            onChange: function(event) {
                this.value = event.target.value;
                this.$emit('update', this.value);
                this.displayGeoUnits (event.target.value);
            },
            displayGeoUnits (geoUnitIds) {
                this.showSpinner = true;
                let ids = geoUnitIds.replace(" ", "").split(",");
                let geoUnitParams = [];
                ids.forEach(function(id) {
                    geoUnitParams.push("ids[]=" + id);
                })
                axios
                    .get('https://res.hotelkey.com/reservas/mvc.php/product_decision_scr_notifications_web_json/GeoUnits/text?' + geoUnitParams.join("&"))
                    .then(response => {
                        if (response.data && response.data.data[0]) {
                            this.destinationsText = response.data.data[0];
                        } else {
                            this.destinationsText = this.invalidGeoUnitsMessage(geoUnitIds);
                        }
                    }).catch(error => {
                        this.destinationsText = this.invalidGeoUnitsMessage(geoUnitIds);
                        this.emitError(error);
                    }).finally (() => {
                        this.showSpinner = false;
                    });
            },
            invalidGeoUnitsMessage(geoUnitIds) {
                return "Los destinos " + geoUnitIds + " no son válidos!!";
            },
            emitError () {
                this.$emit('error', "Se ha producido un error al consultar las geounits.");
            }
        },
        watch: {
            selectedValues: function () {
                if (this.computedValue) {
                    this.displayGeoUnits (this.computedValue);
                }
            }
        }
    }
</script>